export enum ImovoFulfillerActions {
  Redeem = "redeem",
}